import React from 'react';
import { Reveal, FadeIn } from './ScrollReveal';

export default function Guarantee() {
  const items = [
    {
      num: "I",
      title: "Maximale Auswahl, maximale Verantwortung",
      body: "Ich nehme nur Partner an, bei denen ich selbst überzeugt bin, dass das Ziel erreichbar ist. Wer nicht passt, bekommt ein ehrliches Nein — beim ersten Gespräch."
    },
    {
      num: "II",
      title: "Arbeit an den Hebeln, nicht an der Oberfläche",
      body: "Unternehmenswert entsteht durch klarere Entscheidungen, stärkere Führung und eine Strategie, die wirklich umgesetzt wird. Genau dort arbeite ich."
    },
    {
      num: "III",
      title: "36 Monate — Obergrenze, nicht Erwartung",
      body: "Die Verdoppelung kann früher eintreten — und das ist wünschenswert. 36 Monate ist das maximale Zeitfenster, nach dem die Garantie greift. Wer früher liefert, gewinnt früher."
    }
  ];

  return (
    <section id="garantie" className="bg-brand-surface border-y border-brand-border relative z-10">
      <div className="max-w-[1100px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1px_1fr] gap-10 md:gap-0 min-h-[400px]">
          
          <div className="py-12 md:py-20 md:pr-16">
            <Reveal>
              <div className="text-[0.65rem] font-medium tracking-[0.18em] uppercase text-brand-gold mb-6">Die Garantie</div>
              <div className="font-serif text-[clamp(2rem,4vw,3.5rem)] font-light leading-[1.15] text-brand-white tracking-[-0.02em]">
                Ich garantiere die <em className="not-italic italic text-brand-gold">Verdoppelung</em> Ihres Unternehmenswertes — in maximal 36 Monaten.
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-[0.9rem] text-brand-muted leading-[1.8] mt-6 max-w-[420px]">
                Das Ziel kann früher eintreten — und genau das ist das Ziel. 36 Monate ist die Obergrenze, nicht die Erwartung. Ist die Verdoppelung nach 36 Monaten nicht erreicht, arbeite ich weiter. Kostenlos. Bis wir es geschafft haben.
              </p>
              <p className="text-[0.9rem] text-brand-muted leading-[1.8] mt-4 max-w-[420px]">
                Die Zusammenarbeit kann jederzeit mit 4 Wochen Frist beendet werden — das ist bewusst so. Kein Knebelvertrag. Die Garantie ist der Anreiz zu bleiben — nicht der Vertrag.
              </p>
            </Reveal>
          </div>

          <div className="hidden md:block bg-brand-border h-full"></div>

          <div className="py-12 md:py-20 md:pl-16 flex flex-col justify-center">
            <div className="flex flex-col gap-6">
              {items.map((item, i) => (
                <FadeIn key={i} delay={0.2 + (i * 0.1)}>
                  <div className="flex items-start gap-4 pb-6 border-b border-brand-border last:border-b-0 last:pb-0">
                    <div className="w-9 h-9 shrink-0 border border-brand-border2 rounded-[2px] flex items-center justify-center text-brand-gold text-[0.85rem] font-serif">
                      {item.num}
                    </div>
                    <div>
                      <div className="text-[0.85rem] font-medium text-brand-white mb-1.5">{item.title}</div>
                      <div className="text-[0.82rem] text-brand-muted leading-[1.65]">{item.body}</div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}